import React, { Component } from 'react';

import Page from '../../../components/Page';
import DataTable from '../../../components/DataTable';
import { TabHolder, Tab } from '../../../components/Tabs';



import { getCredits } from '../../../utils/apiService';

export default class CreditManagement extends Component{

	constructor(props){
		super(props);

		this.state = {
			credits: []
		};
	}

	componentDidMount(){
		
		getCredits()
			.then((response)=>{
				console.log(response.data);
				this.setState({ credits:response.data })
			})
			.catch(error=>{
				this.setState({ error: true });
			});
	}

	render(){
		const menuItems = [
			{ id: "payment-slips", name: "Payment Slips", active: true },
			{ id: "credit-certs", name: "Credit Certificates" }
		]

		let { credits } = this.state;

		return(
			<Page isAdminPage={ true } pageTitle="Credit Management">
				<div className="clearfix">
					<TabHolder menuItems={ menuItems }>
						
						<Tab menuId={ menuItems[0].id } isActive={ true }>
					
						{ credits.length > 0 ?
					
							<DataTable 
								tableId="slips-table"
								columnTitles={ ["Payment Reference", "Intermediary", "Amount", "Slips", 
									"Cleared", "Created On", "Actions"] }>
							{
								credits.map((credit, index)=>{
									return(
										<tr key={ index }>
											<td>{ credit.payment_reference }</td>
											<td>{ credit.intermediary }</td>
											<td>{ credit.commisions }</td>
											<td>
												<a   
													target="_blank"
													rel="noopener noreferrer"
													href={ credit.policy_document } >
													View
												</a>
											</td>
											<td>{ credit.created }</td>
											<td>{ credit.phone }</td>
											<td>{ credit.email }</td>
											<td>
												<a 
													href={ credit.policy_document } 
													target="_blank" 
													className="btn btn-success btn-sm" rel='noopener noreferrer'>
													View
												</a>
											</td>
											<td >
												<button
													data-toggle="modal" 
													data-target=".edit-insurer-modal"
													className="btn btn-warning btn-sm"
													onClick={ ()=>{ this.editInsurer(credit) } }>
													Edit
												</button>
											</td>
										</tr>
									)
								})
							}
							</DataTable>
						:
							<div className="alert alert-warning">No insurers found</div>
						}
							{/* <Modal 
								title="Edit Insurer"
								className="edit-insurer-modal"
								closable={ true }>

								<UpdateInsurer 
									credit={ credit_insurer }
									onSubmitFn={ this.onUpdateInsurer }
									onChangeFn={ this.onChange } />
							</Modal> */}
						</Tab>

						<Tab menuId={ menuItems[1].id }>
							<DataTable 
								tableId="credit-table"
								columnTitles={ ["Policy No.", "Policy Holder", "Intermediary", "Premium", 
									"Sum Insured", "CFR", "Paid", "Created On", "Actions"] }>

								<tr>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
								</tr>

							</DataTable>
						</Tab>
					</TabHolder>
				</div>
			</Page>
		);
	}
}


// WEBPACK FOOTER //
// ./src/pages/dashboard/payments/CreditManagement.jsx